import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import { useRinglessMessageFieldContext } from 'widgets/MessageFormFields/RinglessMessageField/context/ringlessMessageFieldContext'

export const RinglessMessageFieldRecordAudio = observer(() => {
  const { handleRecordAudio } = useRinglessMessageFieldContext()

  return (
    <>
      <IconButton
        ariaLabel={'Record audio'}
        tooltipProps={{
          label: 'Record audio',
          placement: 'top',
        }}
        icon={'microphone'}
        size={'medium'}
        color={'secondary'}
        variant={'icon'}
        onClick={handleRecordAudio}
      />
    </>
  )
})
